import request from '@/utils/request';

// 获取公司管理列表
export function getCompanyList(data) {
  return request({
    url: '/car/company/dataCompany',
    method: 'post',
    data,
  });
}

// 新增公司
export function addCompany(data) {
  return request({
    url: '/car/company/addCompany',
    method: 'post',
    data,
  });
}

// 删除公司
export function deleteCompany(data) {
  return request({
    url: '/car/company/deleteCompany',
    method: 'post',
    data,
  });
}

// 修改公司
export function updateCompany(data) {
  return request({
    url: '/car/company/updateCompany',
    method: 'post',
    data,
  });
}

// 查看公司
export function detailCompany(data) {
  return request({
    url: '/car/company/detailCompany',
    method: 'post',
    data,
  });
}

// 查询公司树
export function queryCompanyTree() {
  return request({
    url: '/car/company/queryCompanyTree',
    method: 'post',
  });
}

// 查询公司数据
export function selectCompanyData() {
  return request({
    url: '/car/company/selectCompanyData',
    method: 'post',
  });
}
